import { AwardManagerEntity } from "./AwardManagerEntity"
import { BaseModel } from "../Generics/BaseModel"
import { EMoneyConditionType } from "../../Enum/EMoneyConditionType"
import { EAutoType } from "../../Enum/EAutoType"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"

export class AwardEntity extends BaseModel {
  id: number

  status: EEnableStatusType

  minimumValue: number

  countToWin: number

  name: string

  description: string

  awardManagerEntity?: AwardManagerEntity

  isAutomatic: EAutoType

  iconUrl: string

  conditionType: EMoneyConditionType

  valueDiscountWhenWon: number

  constructor(data: Partial<AwardEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.conditionType = data.conditionType ?? EMoneyConditionType.FixedValue

    this.valueDiscountWhenWon = data.valueDiscountWhenWon ?? 0

    this.iconUrl = data.iconUrl ?? ""

    this.isAutomatic = data.isAutomatic ?? EAutoType.Auto

    this.status = data.status ?? EEnableStatusType.Active

    this.minimumValue = data.minimumValue ?? 0

    this.countToWin = data.countToWin ?? 0

    this.name = data.name ?? ""

    this.description = data.description ?? ""
  }

  public override beforeToJSON(): void | Promise<void> {
    this.awardManagerEntity = null
  }

  getValue(coast?: number) {
    if (this.conditionType === EMoneyConditionType.FixedValue || !coast) return this.valueDiscountWhenWon

    return (this.valueDiscountWhenWon / 100) * coast
  }

  getValueToString() {
    if (this.conditionType === EMoneyConditionType.FixedValue) return this.valueDiscountWhenWon.toString().toMoney()

    return `${this.valueDiscountWhenWon}%`
  }

  isWin() {
    if (this.awardManagerEntity) {
      return this.awardManagerEntity.hasAwardToTake
    }

    return false
  }
}
